import type { ApiResponse } from 'types/api.types';

export const EVENT_NAMES = [
  'CLIENT_ADD',
  'CLIENT_UPDATE',
  'CLIENT_DELETE',
  'SNAPSHOT_ADD',
  'SNAPSHOT_DELETE',
  'DATE_LIMITER_UPDATE',
  'PPT_GENERATION',
] as const;

export type EventName = typeof EVENT_NAMES[number];

export const OPERATION_STATUSES = [
  'SUCCESS',
  'FAILED',
  'IN_PROGRESS',
] as const;

export type OperationStatus = typeof OPERATION_STATUSES[number];

export interface EventFilterValues {
  eventName: EventName | '';
  clientName: string;
  operationStatus: OperationStatus | '';
  initiatedBy: string;
}

export interface EventSummary {
  event_id: string;
  event_name: string;
  operation_status: OperationStatus;
  created_at: string;
  initiated_by: string;
  client_id: string | null;
  client_name: string | null;
}

export interface EventDetails extends EventSummary {
  timestamp: string;
  event_data: Record<string, unknown>;
  pk: string;
  sk: string;
}

export interface EventsQuery {
  page: number;
  pageSize: number;
  eventName?: EventName;
  clientName?: string;
  operationStatus?: OperationStatus;
  initiatedBy?: string;
  sortField?: EventSortField;
  sortDirection?: EventSortDirection;
  search?: string;
}

export interface EventsListResponse extends ApiResponse<EventSummary> {
  count: number;
  total_count: number;
  page: number;
  page_size: number;
  total_pages: number;
  sort_by: string;
  sort_direction: EventSortDirection;
}

export interface EventDetailsResponse {
  message: string;
  item: EventDetails | null;
  error: string | null;
}

export const EVENT_SORT_FIELDS = [
  'event_id',
  'event_name',
  'operation_status',
  'created_at',
  'initiated_by',
  'client_id',
  'client_name',
] as const;

export type EventSortField = typeof EVENT_SORT_FIELDS[number];
export type EventSortDirection = 'asc' | 'desc';

export const isEventSortField = (field: string): field is EventSortField =>
  EVENT_SORT_FIELDS.some((eventField) => eventField === field);
